import React, { useRef, useState } from "react";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import Select from "react-validation/build/select";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import { token } from "../Actions/AuthAction";
import { addCandidate } from "../Actions/CandidateAction";
import { useHistory } from "react-router-dom";
import sample from "./Students.xls";
import { emailvalid, phonevalid, required } from "../Common/CommonValidation";
import CheckButton from "react-validation/build/button";
import Loader from "../Common/Loader";

export const AddCandidate = () => {
  const form = useRef();
  const checkBtn = useRef();
  const [loader, setLoader] = useState(false);
  const [firstName, setfirstName] = useState(null);
  const [middleName, setmiddleName] = useState(null);
  const [lastName, setLastName] = useState(null);
  const [gender, setgender] = useState(null);
  const [phone, setPhone] = useState(null);
  const [dateOfBirth, setDateOfBirth] = useState(null);
  const [rollNumber, setRollNumber] = useState(null);
  const [email, setEmail] = useState(null);
  const [excel, setExcel] = useState(null);
  const navigate = useHistory();

  const [flag, setflag] = useState(false);
  const excelUpload = (e) => {
    setflag(true);
    const excelToPost = [];
    const reader = new FileReader();
    reader.readAsBinaryString(e.target.files[0]);
    reader.onload = (e) => {
      const bstr = e.target.result;
      const wb = XLSX.read(bstr, { type: "binary" });
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
      data.shift();
      data.map((citem) => {
        const item = JSON.parse(JSON.stringify(citem));
        if (item[0]) {
          let candidate = {
            email: item[5],
            phone: item[6],
            rollnumber: item[1],
            firstname: item[2],
            middlename: item[3],
            lastname: item[4],
            gender: item[8] === "Male" ? 1 : item[8] === "Female" ? 2 : 3,
            dob: item[7],
          };
          console.log(candidate);
          excelToPost.push(candidate);
        }
      });
      setExcel(excelToPost);
    };
  };
  const getJsonToPost = () => {
    return {
      email: email,
      phone: phone,
      rollnumber: rollNumber,
      firstname: firstName,
      middlename: middleName,
      lastname: lastName,
      gender: gender,
      dob: dateOfBirth,
    };
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    form.current.validateAll();

    if (checkBtn.current.context._errors.length === 0) {
      const jsonToPost = getJsonToPost();
      addCandidateAPI([jsonToPost]);
    }
  };
  const checkError = (model) => {
    let status = [];
    for (let keys in model) {
      if (model[keys].length > 0) {
        status.push(`${model[keys]} ; `);
      }
    }
    if (status.length > 0) {
      return status;
    } else {
      return false;
    }
  };
  const addCandidateAPI = (jsonToPost) => {
    setLoader(true);
    addCandidate({ loginusertoken: token(), candidate: jsonToPost }).then(
      (res) => {
        if (res.status) {
          let error = checkError(res.error[0]);
          if (error) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: error,
            });
          } else {
            Swal.fire({
              icon: "success",
              title: "Done",
              text: "Congractulations!",
              footer: "Student has been added.",
            });
            navigate.push("/candidateslist");
          }
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: res.message,
          });
        }
        setLoader(false);
      }
    );
  };
  const submitExcel = () => {
    console.log(excel);
    if (excel.length == 0) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: "No Data Found",
      });
    } else {
      addCandidateAPI(excel);
    }
  };
  return (
    <React.Fragment>
      {loader && <Loader />}

      <div className="row mb-4">
        <div className="col-md-12">
          <h4 className="table_heading position-relative">ADD CANDIDATE</h4>

          <div className="card formcard mt-3">
            <div className="card-body">
              <label className="small mb-1 d-block" for="inputPassword">
                Upload Candidate Excel
              </label>
              <input
                type="file"
                id="Excel"
                accept=".xls,.xlsx,.csv"
                hidden
                onChange={excelUpload}
              />
              <label for="Excel" className="uploadfile">
                <i className="fa fa-upload" aria-hidden="true"></i> Upload
                Candidate Excel
              </label>
              <a href={sample} className="ml-5" download="Students.xls">
                <i className="fa fa-download" aria-hidden="true"></i> Sample
                File
              </a>
              {flag ? (
                <button
                  className="btn btn-primary-custom mx-5"
                  onClick={submitExcel}
                >
                  Submit Candidate Excel
                </button>
              ) : null}
            </div>
          </div>
        </div>
      </div>

      <div className="card formcard">
        <div className="card-body">
          <Form className="auth_form" ref={form} onSubmit={handleSubmit}>
            <div className="row">
              <div className="form-group col-md-6">
                <label className="small mb-1" for="inputPassword">
                  First Name <span className="text-danger">*</span>
                </label>
                <Input
                  type="text"
                  className="form-control py-4 rounded-pill"
                  placeholder="Enter First Name"
                  name="name"
                  value={firstName}
                  onChange={(e) => setfirstName(e.target.value)}
                  validations={[required]}
                />
              </div>
              <div className="form-group col-md-6">
                <label className="small mb-1" for="inputPassword">
                  Middle Name
                </label>
                <Input
                  type="text"
                  className="form-control py-4 rounded-pill"
                  placeholder="Enter Middle Name"
                  name="name"
                  value={middleName}
                  onChange={(e) => setmiddleName(e.target.value)}
                  // value={name.value}
                  // onChange={(e) => setName({ ...name, value: e.target.value })}
                />
              </div>
              <div className="form-group col-md-6">
                <label className="small mb-1" for="inputPassword">
                  Last Name <span className="text-danger">*</span>
                </label>
                <Input
                  type="text"
                  className="form-control py-4 rounded-pill"
                  placeholder="Enter Last Name"
                  name="name"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  // value={name.value}
                  // onChange={(e) => setName({ ...name, value: e.target.value })}
                  validations={[required]}
                />
              </div>
              <div className="form-group col-md-6">
                <label className="small mb-1" for="inputPassword">
                  Roll no.<span className="text-danger">*</span>
                </label>
                <Input
                  type="text"
                  className="form-control py-4 rounded-pill"
                  placeholder="Enter Roll no."
                  name="name"
                  value={rollNumber}
                  onChange={(e) => setRollNumber(e.target.value)}
                  // value={name.value}
                  // onChange={(e) => setName({ ...name, value: e.target.value })}
                  validations={[required]}
                />
              </div>

              <div className="form-group col-md-6">
                <label className="small mb-1" for="inputPassword">
                  Personal Email <span className="text-danger">*</span>
                </label>
                <Input
                  type="text"
                  className="form-control py-4 rounded-pill"
                  placeholder="Enter Email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  // value={email.value}
                  // onChange={(e) => setEmail({ ...email, value: e.target.value })}
                  validations={[required, emailvalid]}
                />
              </div>
              <div className="form-group col-md-6">
                <label className="small mb-1" for="inputPassword">
                  Phone<span className="text-danger">*</span>
                </label>
                <Input
                  type="text"
                  className="form-control py-4 rounded-pill"
                  placeholder="Enter Phone"
                  name="phone"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  // value={phone.value}
                  // onChange={(e) => setPhone({ ...phone, value: e.target.value })}
                  validations={[required, phonevalid]}
                />
              </div>

              <div className="form-group col-md-6">
                <label className="small mb-1" for="inputPassword">
                  D.O.B<span className="text-danger">*</span>
                </label>
                <Input
                  type="date"
                  className="form-control py-4 rounded-pill"
                  placeholder="Enter Date of Birth"
                  name="website"
                  value={dateOfBirth}
                  onChange={(e) => setDateOfBirth(e.target.value)}
                  // value={website.value}
                  // onChange={(e) => setWebsite({ ...website, value: e.target.value })}
                  validations={[required]}
                />
              </div>
              <div className="form-group col-md-6">
                <label className="small mb-1" for="inputPassword">
                  Gender<span className="text-danger">*</span>
                </label>
                <Select
                  validations={[required]}
                  className="form-control rounded-pill"
                  value={gender}
                  onChange={(e) => setgender(e.target.value)}
                >
                  <option hidden value={null}>
                    Select Gender
                  </option>
                  <option value={1}>Male</option>
                  <option value={2}>Female</option>
                  <option value={3}>Others</option>
                </Select>
              </div>
              <div className="form-group col-md-12 mt-4 mb-0">
                <button className="btn btn-primary-custom mx-2" type="submit">
                  Submit
                </button>
                <CheckButton style={{ display: "none" }} ref={checkBtn} />
                <a className="btn btn-secondary-custom mx-2" href="#">
                  Cancel
                </a>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </React.Fragment>
  );
};
